export const FEATURE_REQUEST_FORM = `https://forms.gle/47vzMxoX3FCkxa457`;

export const HELP_CENTRE_HOME = `https://help.paidnice.com`;

export const WEBHOOKS_ARTICLE = `https://help.paidnice.com/integrations/webhooks`;

export const FIND_SUBSCRIPTION_ARTICLE = `https://help.paidnice.com/billing/invoices-card-and-billing-owner#change-the-billing-owner`;

export const ICS_ARTICLE = `https://help.paidnice.com/emails/how-reminder-emails-work`;

export const ACTIONS_ARTICLE = `https://help.paidnice.com/getting-started/work-with-the-actions-page`;

export const ESCALATIONS_ARTICLE = `https://help.paidnice.com/escalations/how-escalations-work`;

export const BANK_OF_ENGLAND_ARTICLE = `https://help.paidnice.com/late-fees/how-late-fees-work#uk-businesses`;

export const SAFE_MODE_ARTICLE = `https://help.paidnice.com/getting-started/go-live-checklist#draft-active-and-safe-mode`;

export const GROUPS_POLICIES_ARTICLE = `https://help.paidnice.com/getting-started/how-paidnice-works`;

export const TERMS_AND_CONDITIONS = `https://paidnice.com/terms`;

export const PRIVACY_POLICY = `https://paidnice.com/privacy`;
